import { routes } from "@/constants/url";
import { useWorkspaceNavigate } from "@/lib/router/use-workspace-navigate";
import { NewTrackingEvent } from "@/lib/track/track-event";
import { trackNewEvent } from "@/lib/track/track-event";
import { cn } from "@/lib/utils";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Typography,
} from "@backpac/monica";
import { useChannelAnalytics } from "../hooks/use-channel-analytics";
import { ChannelItem } from "./channel-item";

export const ChannelList = () => {
  return (
    <div className="py-4">
      <ChannelList.Carousel />
    </div>
  );
};

ChannelList.Carousel = function ChannelListCarousel() {
  const { channelId, setChannelId, channels } = useChannelAnalytics();

  return (
    <Carousel className={cn("mr-[-16px]")}>
      <CarouselContent className="flex">
        {channels.map((channel) => (
          <CarouselItem key={channel.id} className="basis-auto">
            <ChannelItem
              key={channel.id}
              channel={channel}
              selected={channelId === channel.id}
              onClick={() => setChannelId(channel.id)}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      {channels.length >= 6 && (
        <>
          <CarouselPrevious />
          <CarouselNext />
        </>
      )}
    </Carousel>
  );
};

ChannelList.Pending = () => (
  <div className="h-14 flex gap-4">
    {new Array(2).fill(null).map((_, index) => (
      <ChannelItem.Pending key={index} />
    ))}
  </div>
);

ChannelList.ConnectChannelBanner = () => {
  const navigate = useWorkspaceNavigate();
  return (
    <Card className={cn("bg-[#F5FFB9] flex items-center justify-between shadow-standard")}>
      <div>
        <CardHeader className="space-y-2">
          <Typography asChild size="md" weight={600}>
            <CardTitle>🔗 Connect Your YouTube Channel</CardTitle>
          </Typography>
          <Typography asChild size="sm" color="textMuted">
            <CardDescription>
              Easily add your YouTube channel to access personalized analytics and performance data
            </CardDescription>
          </Typography>
        </CardHeader>
        <CardContent>
          <Button
            withArrow={true}
            onClick={() => {
              trackNewEvent(NewTrackingEvent.ClickGetStartedButton, {});
              navigate(routes.CHANNELS.root);
            }}
            size="md"
          >
            Get started
          </Button>
        </CardContent>
      </div>
      <img src="/assets/connect-banner-image.png" width={200} alt="Connect banner" className="mr-6 hidden sm:block" />
    </Card>
  );
};
